<p-progressSpinner class="spinner_in_front" *ngIf="spinner"></p-progressSpinner>
<div class="panel_wrapper">
    <div class="d-flex flex-row justify-content-between pb-2">
        <div class="d-flex flex-row">
            <img class="edit_employee_profile_picture" (click)="cropAndCompressImageDialog()"
                [src]="determineImageUrl(addOrEditSubcategoryModel.pictureURL)"
                alt="profile-picture">
            <div class="picture-edit align-self-center">
                <p class="hide_mobile primary_medium_text_16 m-0">
                  {{ 'SUBCATEGORY.UPLOAD_IMAGE_MESSAGE' | translate }}
                    <label *ngIf="pictureIsWrongFormat">
                        <i class="pi pi-exclamation-circle me-1 error_color wrong_format_tooltip"
                            pTooltip="{{'SUBCATEGORY.WRONG_FORMAT' | translate}}" tooltipPosition="top"></i>
                    </label>
                    <label *ngIf="errorModel!=null && errorModel['Image']!=null">
                      <i class="pi pi-exclamation-circle me-1 error_color wrong_format_tooltip"
                         pTooltip="{{ errorModel['Image'] | translate }}" tooltipPosition="top"></i>
                    </label>
                </p>
                <p class="show_mobile primary_medium_text_16 m-0">
                    {{ 'SUBCATEGORY.UPLOAD_IMAGE_MESSAGE_MOBILE' | translate }}
                      <label *ngIf="pictureIsWrongFormat">
                          <i class="pi pi-exclamation-circle me-1 error_color wrong_format_tooltip"
                              pTooltip="{{'SUBCATEGORY.WRONG_FORMAT' | translate}}" tooltipPosition="top"></i>
                      </label>
                      <label *ngIf="errorModel!=null && errorModel['Image']!=null">
                        <i class="pi pi-exclamation-circle me-1 error_color wrong_format_tooltip"
                           pTooltip="{{ errorModel['Image'] | translate }}" tooltipPosition="top"></i>
                      </label>
                  </p>
            </div>
        </div>
    </div>

    <div class="display_block_mbl d-flex flex-row justify-content-between pb-2">
        <div class="w_100_mbl w-50">
            <label class="lbl_pos_field">{{'SUBCATEGORY.SUBCATEGORY_NAME' | translate}}
                <i *ngIf="errorModel!=null && errorModel['Name']!=null"
                    class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
                    pTooltip="{{errorModel['Name']|translate}}" tooltipPosition="top"></i>
            </label>
            <input type="text" class="primary_input_field" [(ngModel)]="addOrEditSubcategoryModel.name">
            <label class="lbl_pos_field">{{'SUBCATEGORY.ADD_TO_CATEGORY' | translate}}
                <i *ngIf="errorModel!=null && errorModel['ParentId']!=null"
                    class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
                    pTooltip="{{errorModel['ParentId']|translate}}" tooltipPosition="top"></i>
            </label>
            <p-dropdown class="pos_dropdown" [options]="categoriesDropdownHelperModels"
                [(ngModel)]="addOrEditSubcategoryModel.parentId" optionLabel="name" optionValue="id"
                placeholder="{{'SUBCATEGORY.SELECT_CATEGORY' | translate}}"></p-dropdown>

        </div>
        <div class="w_100_mbl w-50">
            <label class="lbl_pos_field w-25">{{'SUBCATEGORY.DESCRIPTION' | translate}}</label>
            <label class="lbl_pos_field text-end float-end w-25" *ngIf="addOrEditSubcategoryModel.description">
              {{255 - addOrEditSubcategoryModel.description.length}}/255</label>
            <textarea rows="4" cols="50" class=" dsc_text_area" maxlength="255"
                [(ngModel)]="addOrEditSubcategoryModel.description"></textarea>
        </div>
    </div>
    <div class="d-flex flex-row justify-content-between pb-2">
        <button *ngIf="!enableEdit" class="btn_login w-100" (click)="addSubcategory(addOrEditSubcategoryModel)">{{
            'SAVE' |
            translate}}</button>
        <button *ngIf="enableEdit" class="btn_login w-100" (click)="editSubcategory(addOrEditSubcategoryModel)">{{
            'SAVE' |
            translate}}</button>
    </div>
</div>
